import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TransformIcon(props: IconProps) {
    return <Icon {...props} iconKey={"transform"}/>
}
